import type { Locale } from "./i18n";

export function browserLocale(locale: Locale): "sq-AL" | "en-GB" {
  return locale === "sq" ? "sq-AL" : "en-GB";
}

export function formatPlatformTime(value: string | Date, locale: Locale): string {
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(browserLocale(locale), {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(date);
}

export function formatPlatformWeekday(value: string | Date, locale: Locale, width: "short" | "long" = "long"): string {
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(browserLocale(locale), { weekday: width }).format(date);
}
